import axios from 'axios'
import { trackPromise } from 'react-promise-tracker'
import { getWarehouses } from '../reports/ReportsFunctions'
import { getProductsList } from '../products/ProductsFunctions'

export const getStockOutByID = async (app, so_id) => {
    let so = null
    app.startLoadingIndicator("Reading StockOut")
    await trackPromise (
        axios.get(app.API_URI + `/stockout?stockout_id=${so_id}`)
        .then(result => {
            so = result.data
            app.stopLoadingIndicator()
        })
        .catch(error => { app.errorLoadingIndicator(error) })
    )
    return so
}

export const getStockOutList = async (app, filter) => {
    let stockout_list = null
    app.startLoadingIndicator()
    if (filter) {
        await trackPromise (
            axios.get(app.API_URI + `/stockout/filter?dr_from=${filter.date.date_released_from}&dr_to=${filter.date.date_released_to}&dc_from=${filter.date.date_created_from}&dc_to=${filter.date.date_created_to}`)
            .then(result => {
                stockout_list = result.data
                app.stopLoadingIndicator()
            })
            .catch(error => { app.errorLoadingIndicator(error) })
        )
    } else {
        await trackPromise (
            axios.get(app.API_URI + '/stockout')
            .then(result => {
                stockout_list = result.data
                app.stopLoadingIndicator()
            })
            .catch(error => { app.errorLoadingIndicator(error) })
        )
    }
    return stockout_list
}

export const getStockOutSettings = async (app) => {
    let so_settings = null
    const user_id = (app.client.signed_in === 'admin') ? app.client.signed_in : app.client.signed_in.id
    app.startLoadingIndicator()
    await trackPromise (
        axios.get(app.API_URI + `/settings?user_id=${user_id}&field=stock_out`)
        .then(result => {
            so_settings = result.data
            app.stopLoadingIndicator()
        })
        .catch(error => { app.errorLoadingIndicator(error) })
    )
    return so_settings
}

export const saveStockOutSettings = async (app, data) => {
    let save_settings = null
    const user_id = (app.client.signed_in === 'admin') ? app.client.signed_in : app.client.signed_in.id
    app.startLoadingIndicator("Saving settings")
    await trackPromise (
        axios.put(app.API_URI + `/settings?user_id=${user_id}&field=stock_out`, data)
        .then(result => {
            save_settings = result.data
            app.stopLoadingIndicator()
        })
        .catch(error => { app.errorLoadingIndicator(error) })
    )
    return save_settings
}

export const saveStockOut = async (app, stockout, silent=false) => {
    let stock_out = null

    stockout.signed_in = app.client.signed_in

    if (!silent) app.startLoadingIndicator("Saving StockOut")
    /** It's a new StockOut (save) */
    if (!stockout._id)
        await trackPromise (
            axios.post(app.API_URI + `/stockout`, stockout)
            .then(result => {
                stock_out = result.data
                if (!silent) app.stopLoadingIndicator()
            })
            .catch(error => { app.errorLoadingIndicator(error) })
        )
    /** Existing StockOut (update) */
    else
        await trackPromise (
            axios.put(app.API_URI + `/stockout?stockout_id=${stockout._id}`, stockout)
            .then(result => {
                stock_out = result.data
                if (!silent) app.stopLoadingIndicator()
            })
            .catch(error => { app.errorLoadingIndicator(error) })
        )
    return stock_out
}

export const deleteStockOut = async (app, so_id) => {
    let stock_out = null
    app.startLoadingIndicator("Deleting StockOut")
    await trackPromise (
        axios.delete(app.API_URI + `/stockout?stockout_id=${so_id}`)
        .then(result => {
            stock_out = result.data
            app.stopLoadingIndicator()
        })
        .catch(error => { app.errorLoadingIndicator(error) })
    )
    return stock_out
}

export const deleteStockInAutoPosted = async (app, ref_id) => {
    let delete_stockin_ap = null
    app.startLoadingIndicator("Deleting StockOut")
    await trackPromise (
        axios.delete(app.API_URI + `/stockin?reference_code=${ref_id}`)
        .then(result => {
            delete_stockin_ap = result.data
            app.stopLoadingIndicator()
        })
        .catch(error => { app.errorLoadingIndicator(error) })
    )
    return delete_stockin_ap
}

export const restoreStockOut = async (app, so_id) => {
    let restore_so = null
    app.startLoadingIndicator("Restoring itesm to the inventory")
    await trackPromise (
        axios.post(app.API_URI + `/stockout/restore?stockout_id=${so_id}`)
        .then(result => {
            restore_so = result.data
            app.stopLoadingIndicator()
        })
        .catch(error => { app.errorLoadingIndicator(error) })
    )
    return restore_so
}

export { getProductsList, getWarehouses }